<template>
  <div
    class="position-absolute"
    :class="setSemitransparent ? 'semitransparent' : ''"
    id="bitRelational"
  >
    <el-tabs v-model="activeName" type="border-card" class="h-full">
      <el-tab-pane label="关联数据" class="text-12px">
        <!-- <el-row
          class="p-20px border-color-grey-f5-bottom"
          v-for="(item, index) in bitBasicAttrData"
          :key="index"
        >
          <el-col :span="7" class="has-text-weight-semibold">{{ item.name }}：</el-col>
          <el-col :span="17">{{ item.value }}</el-col>
        </el-row> -->
        <el-tabs ref="linkedDataTabs" v-model="linkedDataActiveName">
          <el-tab-pane label="已关联对象" name="linkedData"></el-tab-pane>
          <el-tab-pane label="智能推荐" name="recommendData"></el-tab-pane>
        </el-tabs>
        <div v-if="linkedDataActiveName === 'linkedData'">
          <!-- 基本属性 -->
          <div class="w-full mb-10px">
            <div
              class="border-l-3 border-color-primary flex-1 text-14px pl-10px mt-10px font-weight-600"
            >
              基本属性
            </div>
            <div class="mb-10px p-10px" v-if="classTypeTableData.length > 0">
              <el-row class="leading-24px" v-for="(item, index) in classTypeTableData" :key="index">
                <el-col :span="8" class="text-[#515a6e] font-weight-600">{{ item.name }}：</el-col>
                <el-col :span="16" class="text-[#515a6e]">{{ item.value }}</el-col>
              </el-row>
            </div>
          </div>
          <!-- 其他属性 -->
          <div v-for="(value, key, index) in dynamicTableGroupData" :key="index">
            <div
              class="border-l-3 border-color-primary flex-1 text-14px pl-10px mt-10px font-weight-600"
            >
              {{ key }}
            </div>
            <div class="mb-10px p-10px">
              <el-row class="leading-24px" v-for="(cItem, cIndex) in value" :key="cIndex">
                <el-col :span="8" class="text-[#515a6e] font-weight-600">{{ cItem.name }}：</el-col>
                <el-col :span="16" class="text-[#515a6e]">{{ cItem.value }}</el-col>
              </el-row>
              <!-- 扩展属性一对多列表 -->
              <div v-if="flag === 1 && value.length === 0">
                <el-table
                  class="text-12px"
                  :data="extendValueList"
                  :highlight-current-row="true"
                  :header-cell-style="{ textAlign: 'center' }"
                  :cell-style="{ textAlign: 'center' }"
                  height="248"
                  row-key="id"
                  stripe
                >
                  <el-table-column
                    type="index"
                    width="65"
                    label="序号"
                    prop="seqNo"
                  ></el-table-column>
                  <el-table-column
                    v-for="(item, index) in extendTableHeader"
                    :key="index"
                    :label="item.name"
                    :prop="`${item.tableName}.${item.columnName}`"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{ scope.row[`${item.tableName}.${item.columnName}`] }}
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  class="mt-20px"
                  background
                  @size-change="searchList()"
                  @current-change="getList()"
                  :current-page.sync="page.pageNo"
                  :page-sizes="$pageSizeAll"
                  :page-size.sync="page.pageSize"
                  layout="->, total, sizes, prev, pager, next"
                  :total="page.total"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
        <!-- 关联数据的智能推荐 -->
        <div v-else-if="linkedDataActiveName === 'recommendData'">
          <div class="mb-20px">
            <el-input
              type="text"
              class="w-260px"
              v-model="linkedDataKeyword"
              placeholder="请输入关键字"
              clearable
            />
            <el-button type="primary" class="ml-10px" @click="getSmartRecommendQuery"
              >搜索</el-button
            >
          </div>
          <div
            v-if="!recommendLinkedDataList.length"
            class="text-center text-14px !text-[#909399] mt-50px"
          >
            暂无数据
          </div>
          <div v-for="item in recommendLinkedDataList" :key="item.id">
            <div v-for="(value, key) in item" :key="key">
              <div v-if="key === 'basic'">
                <div
                  class="border-l-3 border-color-primary flex-1 text-14px pl-10px mt-10px font-weight-600"
                >
                  <span>基本属性</span>
                </div>
                <div class="p-10px">
                  <el-row
                    class="leading-24px"
                    v-for="(cValue, cKey, cIndex) in value"
                    :key="cIndex"
                  >
                    <el-col :span="8" class="text-[#515a6e] font-weight-600">{{ cKey }}：</el-col>
                    <el-col :span="16" class="text-[#515a6e]">{{ cValue }}</el-col>
                  </el-row>
                </div>
              </div>
              <div v-if="key === 'class'">
                <div
                  class="border-l-3 border-color-primary flex-1 text-14px pl-10px mt-10px font-weight-600"
                >
                  <span>{{ item.className }}</span>
                </div>
                <div class="p-10px">
                  <el-row
                    class="leading-24px"
                    v-for="(cValue, cKey, cIndex) in value"
                    :key="cIndex"
                  >
                    <el-col :span="8" class="text-[#515a6e] font-weight-600">{{ cKey }}：</el-col>
                    <el-col :span="16" class="text-[#515a6e]">{{ cValue }}</el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <el-divider></el-divider>
          </div>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="模板属性">
        <el-tabs class="scroll-y tabs-item-box" type="card">
          <el-tab-pane
            :label="'位号通用属性'"
            v-if="generalAttributeIndex !== -1 || DisplayNoDataAttribute === 'true'"
          >
            <div v-if="!_.isEmpty(generalAttribute)">
              <div
                class="demo-input-suffix text-12px"
                v-for="list in generalAttribute"
                :key="list.columnName"
              >
                <div v-if="list.value || DisplayNoDataAttribute === 'true'" class="mb-10px">
                  <el-row class="p-10px border-color-grey-f5-bottom" :gutter="20">
                    <el-col :span="10" class="has-text-weight-semibold">
                      <div class="label-title">{{ list.attrbuteDetail.name }}：</div>
                    </el-col>
                    <el-col :span="14">{{ list.attrValue }}</el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div v-else class="el-table__empty-block" style="width: 100%">
              <span class="el-table__empty-text">暂无数据</span>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="item.name" v-for="(item, index) in templateAttrSetList" :key="index">
            <div v-if="!_.isEmpty(item.attributeList)">
              <div
                class="demo-input-suffix text-12px"
                v-for="list in item.attributeList"
                :key="list.columnName"
              >
                <div v-if="list.value || DisplayNoDataAttribute === 'true'" class="mb-10px">
                  <el-row class="p-10px border-color-grey-f5-bottom" :gutter="20">
                    <el-col :span="10" class="has-text-weight-semibold">
                      <div class="label-title">{{ list.name }}：</div>
                    </el-col>
                    <el-col :span="14">{{ list.value }}</el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div v-else class="el-table__empty-block" style="width: 100%">
              <span class="el-table__empty-text">暂无数据</span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane> -->
      <!-- <el-tab-pane label="关联位号">
        <el-tree
          class="text-14px"
          :highlight-current="true"
          :data="treeDatas"
          :props="defaultProps"
          accordion
          @node-click="clickTagNode"
          :expand-on-click-node="false"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <el-tooltip
              effect="dark"
              :content="`${data.nodeCode}[${data.nodeName}]`"
              placement="top"
              :open-delay="1000"
            >
              <span v-if="data.nodeCode">{{ data.nodeCode }}[{{ data.nodeName }}]</span>
            </el-tooltip>
            <el-tooltip effect="dark" :content="data.nodeName" placement="top" :open-delay="1000">
              <span v-if="!data.nodeCode">{{ data.nodeName }}</span>
            </el-tooltip>
          </span>
        </el-tree>
      </el-tab-pane> -->
      <el-tab-pane label="关联文档">
        <el-tabs ref="relatedDocTabs" v-model="relatedDocActiveName">
          <el-tab-pane label="已关联文档" name="relatedDoc"></el-tab-pane>
          <el-tab-pane label="智能推荐" name="recommendDoc"></el-tab-pane>
        </el-tabs>
        <!-- 已关联文档 -->
        <div class="h-full overflow-auto" v-if="relatedDocActiveName === 'relatedDoc'">
          <el-tree :highlight-current="true" :data="treeFiles" :props="defaultDocProps" accordion>
            <el-row class="custom-tree-node w-full" slot-scope="{ node, data }">
              <el-tooltip
                :content="
                  data.documentName
                    ? `${docRelationFieldSeq ? node.label : data.documentName}[${
                        docRelationFieldSeq ? data.documentName : node.label
                      }]`
                    : node.label
                "
                placement="top"
                :open-delay="1000"
              >
                <el-col
                  v-if="data.documentName"
                  :span="20"
                  class="text-overflow text-12px h-32px"
                  style="overflow: hidden"
                >
                  <p class="node-treeLable" :class="{ activeColor: data.isTopping === 0 }">
                    {{ data.documentName }}
                    [{{ data.fileName }}]
                  </p>
                </el-col>
                <el-col
                  v-else
                  :span="20"
                  class="text-overflow text-12px h-32px"
                  style="overflow: hidden"
                >
                  <p class="node-treeLable">{{ node.label }}</p>
                </el-col>
              </el-tooltip>
              <el-col
                v-if="!node.childNodes.length"
                :span="4"
                class="text-overflow h-32px leading-32px text-color-blue tc"
                style="overflow: hidden"
              >
                <!-- <el-button @click="viewMore(node)" size="mini">预览</el-button>
                <el-button @click="splitScreen(node)" size="mini">分屏</el-button> -->
                <img
                  src="../../../assets/images/dialog.png"
                  title="预览"
                  class="inline-block mr-5px"
                  @click="viewMore(node)"
                />
                <img
                  src="../../../assets/images/split_screen.png"
                  title="分屏"
                  class="inline-block"
                  @click="splitScreen(node)"
                />
              </el-col>
            </el-row>
          </el-tree>
        </div>
        <!-- 已关联文档的智能推荐 -->
        <div class="h-full overflow-auto" v-show="relatedDocActiveName === 'recommendDoc'">
          <div class="mb-20px">
            <el-input
              type="text"
              class="w-260px"
              v-model="recommendDocKeyword"
              placeholder="请输入关键字"
              clearable
            />
            <el-button type="primary" class="ml-10px" @click="getDocSmartRecommendQuery"
              >搜索</el-button
            >
          </div>
          <el-tree
            :highlight-current="true"
            :data="smartTreeFiles"
            :props="smartDocProps"
            accordion
          >
            <el-row class="custom-tree-node w-full" slot-scope="{ node, data }">
              <el-tooltip
                :content="
                  data.fileName ? `${data.documentName}[${data.fileName}]` : data.documentName
                "
                placement="top"
                :open-delay="1000"
              >
                <el-col :span="20" class="text-overflow text-12px h-32px" style="overflow: hidden">
                  <p class="node-treeLable" :class="{ activeColor: data.isTopping === 0 }">
                    {{ data.documentName }}
                    <span v-if="data.fileName">[{{ data.fileName }}]</span>
                  </p>
                </el-col>
              </el-tooltip>
              <el-col
                v-if="data.isLeaf && !node.childNodes.length"
                :span="4"
                class="text-overflow h-32px leading-32px text-color-blue tc"
                style="overflow: hidden"
              >
                <img
                  src="../../../assets/images/dialog.png"
                  title="预览"
                  class="inline-block mr-5px"
                  @click="viewMore(node)"
                />
                <img
                  src="../../../assets/images/split_screen.png"
                  title="分屏"
                  class="inline-block"
                  @click="splitScreen(node)"
                />
              </el-col>
            </el-row>
          </el-tree>
        </div>
      </el-tab-pane>
      <el-tab-pane label="关联模型">
        <div
          v-if="!associativeMdelsList.length"
          class="text-center text-14px !text-[#909399] mt-50px"
        >
          暂无数据
        </div>
        <el-row
          class="mt-20px hover-color"
          v-for="(item, index) in associativeMdelsList"
          :key="index"
          v-else
        >
          <el-col :span="12" class="text-12px leading-24px cursor-pointer">
            {{ item.modelName }}
          </el-col>
          <el-col :span="12" class="text-12px text-right cursor-pointer">
            <img
              src="../../../assets/images/dialog.png"
              title="预览"
              class="inline-block mr-5px"
              @click="viewModel(item)"
            />
            <!-- <img
              src="../../../assets/images/split_screen.png"
              title="分屏"
              class="inline-block"
              @click="splitScreen(item)"
            /> -->
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <!-- 文件预览弹框 -->
    <el-dialog
      v-if="centerDialogVisible"
      :title="`${previewFileName}`"
      top="2%"
      width="80%"
      :visible.sync="centerDialogVisible"
      :modal-append-to-body="false"
      center
      v-dialogDrag
    >
      <!-- svg通过iframe预览 -->
      <iframe
        v-if="previewSvgType === 'svg'"
        :src="svgUrl"
        width="100%"
        height="740px"
        class="myiframe"
        allowfullscreen
      ></iframe>
      <!-- 文件预览【kkfileview微服务预览】 -->
      <div v-else class="w-full h-740px" id="associatedFiles"></div>

      <!-- <img
        :src="previewVersionTag === 0 ? 'static/img/gz/在用.png' : 'static/img/gz/弃用.png'"
        alt
        v-if="versionManagement === 'true'"
        class="position-absolute"
        style="right: 10px; top: 65px"
      /> -->
      <!-- 图片预览 -->
      <!-- <div
        id="splitImgDom"
        class="w-full h-800px flex justify-center"
        v-if="imgTypeList.includes(previewSvgType.toLowerCase())"
      >
        <img v-move :src="resourceUrl" id="splitImg" class="h-800px" />
      </div> -->
      <!-- <p v-if="previewSvgType === 'pdf'" class="height-20 fz-14 has-text-right text-color-blue">
        操作提示：Ctrl + 鼠标滚轮中键 可放大缩小
      </p> -->
      <!-- <iframe
        v-if="previewSvgType === 'wizdrawing' && showIframe"
        ref="htFrame"
        :src="htPage"
        width="100%"
        height="800px"
        class="myiframe"
        allowfullscreen
        @load="htLoad"
      ></iframe> -->
      <!-- pdf预览 -->
      <!-- <iframe
        v-else-if="showIframe && previewSvgType === 'pdf'"
        width="100%"
        height="800px"
        :src="`/lib/pdfjs/web/viewer.html?file=${resourceUrl}`"
        allowfullscreen
        allow="autoplay"
        class="myiframe"
      ></iframe> -->
      <!-- 其他文件预览 -->
      <!-- <iframe
        :src="resourceUrl"
        width="100%"
        height="800px"
        v-else-if="showIframe && !['svg', 'pdf'].includes(previewSvgType)"
        allowfullscreen
        allow="autoplay"
        class="myiframe"
      ></iframe> -->
    </el-dialog>
  </div>
</template>
<script>
import DocumentService from '@/services/DocumentService'
import documentManagementService from '@/services/documentManagement'
import ModelParsingTaskService from '@/services/ModelParsingTaskService'
import { ModelApi } from '@wiz-api/material-management'
import qs from 'qs'

const modelApi = new ModelApi()

export default {
  name: 'bitRelational',
  components: {},
  props: {
    currentModel: {
      type: Object,
      default: () => {},
    },
    setSemitransparent: {
      type: Boolean,
      default: () => {},
    },
    currentFileCode: {
      type: String,
      default: () => {},
    },
  },
  data() {
    return {
      imgTypeList: ['bmp', 'jpg', 'jpeg', 'png', 'gif', 'webp'],
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      mainFileType: '', // 主屏文件类型
      previewFileName: '', // 预览文件名称
      previewVersionTag: 0,
      previewSvgType: '',
      showIframe: false,
      centerDialogVisible: false, // 测试树结构图片预览
      resourceUrl: '',
      activeName: '',
      linkedDataActiveName: 'linkedData',
      relatedDocActiveName: 'relatedDoc',
      bitBasicAttrForm: {
        nameSpace: '',
        code: '',
        name: '',
        shortDescription: '',
        longDescription: '',
        tagClassName: '',
      },
      bitBasicAttrData: [],
      categoryValue: '',
      typeList: [],
      treeData: [],
      defaultProps: {
        // 关联属性配置
        label: (data) => {
          if (data.nodeCode) {
            return `${data.nodeCode}[${data.nodeName}]`
          }
          return data.nodeName
        },
        children: 'childrenNodes',
      },
      defaultDocProps: {
        // 关联文档配置
        label: (data) => {
          if (data.documentName) {
            return `${data.nodeName}[${data.documentName}]`
          }
          return data.nodeName
        },
        children: 'childrenNodes',
      },
      treeFile: [],
      topBiteTagId: '', // 关联位号选中的tagId（top）
      basicPropertyLists: [],
      generalAttrSet: {
        // 位号基本属性的一般属性扩展数据
        attrValueList: [],
      },
      enumValueList: [],
      currencyChecked: false, // 位号的基本属性的多选按钮
      currencyEnumValue: [], // 位号的基本属性的枚举类型
      defaultPropes: {
        value: 'name',
        children: 'nodes',
        label: 'name',
      },
      templateAttrSetList: [], // 模板属性
      generalAttribute: [], // 位号通用属性
      generalAttributeIndex: -1,
      checked: false, // 位号的模板属性的多选按钮
      htPage: `${window.location.origin}/static/ht/htView.html`, // ht预览页面路径
      treeDatas: [],
      treeFiles: [],
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      dynamicTableData: [],
      classTypeTableData: [],
      dynamicTableGroupData: [],
      codeInfo: {},
      standardId: '',
      isExtend: null,
      isPrimary: null,
      extendValue: null,
      flag: null,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      linkedDataKeyword: '',
      recommendDocKeyword: '',
      recommendLinkedDataList: [],
      recommendDocDataList: [],
      associativeMdelsList: [],
      smartTreeFiles: [],
      smartDocProps: {
        label: 'documentName',
        children: 'files',
      },
      svgUrl: '', // svg预览URL
    }
  },
  watch: {
    currentModel: {
      deep: true,
      immediate: true,
      handler(val) {
        // console.log(val, '000')
        if (val && val.classId) {
          this.codeInfo = val
          this.standardId = localStorage.getItem('standardId') || ''
          this.getDynamicTableData()
          this.getSmartRecommendQuery()
          this.getDocSmartRecommendQuery()
          this.getAssociativeMdels()
        }
      },
    },
    resourceUrl() {
      this.showIframe = false
      if (!this.imgTypeList.includes(this.previewSvgType.toLowerCase())) {
        this.$nextTick(() => {
          this.showIframe = true
        })
      }
    },
    centerDialogVisible(bol) {
      this.$emit('changeIconCollapaseZindex', !bol)
    },
    generalAttribute: {
      deep: true,
      handler(attributeList) {
        this.generalAttributeIndex = _.findIndex(attributeList, (attribute) => {
          return attribute.value
        })
      },
    },
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `${window.location.origin}/#/${routerBase}`
    },
    // 设置关联位号树结构
    // treeDatas() {
    //   return _.map(this.treeData, (val) => {
    //     return {
    //       name: val.type,
    //       relation: _.isArray(val.relation) ? val.relation : val.relation ? [val.relation] : [],
    //     }
    //   })
    // },
    // 设置关联文件树结构
    // treeFiles() {
    //   // 根据那边code编辑是否在这边找的到对应的文档编码，如果一致就置顶和高亮
    //   return _.map(this.treeFile, (val) => {
    //     return {
    //       fileName: val.name,
    //       documenFileList: _.sortBy(
    //         _.map(val.documenFileList, (item) => {
    //           return {
    //             ...item,
    //             isTopping: item.documentCode === this.currentFileCode ? 0 : 1, // 0为置顶和高亮，1为不需要置顶和高亮
    //           }
    //         }),
    //         ['isTopping']
    //       ),
    //       fileId: val.id,
    //     }
    //   })
    // },
    DisplayNoDataAttribute() {
      const DisplayNoDataAttribute =
        _.find(this.systemParams, { parameterCode: 'DisplayNoDataAttribute' }) || {}
      return DisplayNoDataAttribute.parameterValue || 'true'
    },
    versionManagement() {
      const version = _.find(this.systemParams, { parameterCode: 'versionManagement' }) || {}
      return version.parameterValue
    },
    // 关联文档文件名称组合顺序
    docRelationFieldSeq() {
      const seq = _.find(this.systemParams, { parameterCode: 'docRelationFieldSeq' }) || {}
      return seq && seq.parameterValue === 'code'
    },
    // 文件服务地址
    standardServer() {
      return Wiz.GetModuleConfig('legacy-resource')?.currentEnv?.VUE_APP_STANDARD_SERVER
    },
    // 文件预览服务地址
    filePreviewServer() {
      return Wiz.GetModuleConfig('legacy-resource')?.currentEnv?.VUE_APP_FILE_PREVIEW_SERVER
    },
  },
  created() {
    this.$nextTick(() => {
      this.$refs.linkedDataTabs.$el.querySelector('.el-tabs__active-bar').style.width = '60px'
      this.$refs.relatedDocTabs.$el.querySelector('.el-tabs__active-bar').style.width = '60px'
    })
  },
  methods: {
    // ht加载
    htLoad() {
      const $window = this.$refs.htFrame.contentWindow
      $window.init(this.resourceUrl)
      if (this.currentEnv.VUE_APP_CURRENT_PROJECT === 'GZ') {
        setTimeout(() => {
          $window.setColorChange()
        }, 500)
        this.htTimer = setInterval(() => {
          $window.setColorChange()
        }, 8000)
      }
    },
    // 获取预览URL
    getPreviewUrl(fileName, fileId) {
      const fileNameType = _.last(_.split(fileName, '.')) // 文件格式
      const filePreviewServerUrl = `${this.filePreviewServer}/#/file-preview`
      let url = `url=${this.standardServer}/api/std/file/kkfileview/${fileId}.${fileNameType}` // 大部分文件格式通用
      if (fileNameType === 'svg') {
        url = `url=${this.standardServer}/api/std/file/${fileId}`
      }
      const type = `type=${fileNameType}&name=resource.${fileNameType}`
      return `${filePreviewServerUrl}?${url}&${type}`
    },
    // 关联文档树结构预览
    async viewMore(data) {
      console.log(data, 'data')
      data.data.fileName = data.data.nodeName
      data.data.md5 = data.data.fileId
      this.previewSvgType = _.split(data.data.fileName, '.')[1]

      // 如果是pr模型就直接跳转新窗口查看
      if (this.previewSvgType === 'pr') {
        const prQuery = {
          documentId: data.data.documentId,
          title: '',
          standardId: this.standardId,
          classId: this.codeInfo.classId,
          isVersion: '0', // 是否是历史版本查看
          token: localStorage.getItem('authorization'),
        }
        const previewUrl = `${this.basePath}/fullscreen/model-doc-view/index?${qs.stringify(
          prQuery
        )}`
        window.open(previewUrl, '_blank')
        // window.open(`/#/docView?documentId=${data.data.documentId}`)
        return
      }
      // 其他格式文件预览
      const previewUrl = this.getPreviewUrl(data.data.fileName, data.data.fileId)
      console.log(previewUrl, data, 'HHH')

      if (this.previewSvgType === 'svg') {
        // 先设置新的URL,再打开弹窗
        this.svgUrl = ''
        this.$nextTick(() => {
          this.svgUrl = previewUrl
          this.centerDialogVisible = true
        })
      } else {
        // 非svg文件先打开弹窗
        this.centerDialogVisible = true
        // 启动文件预览服务
        window.wujie.setupApp({
          name: 'associatedFiles', // 启动kkfileview微服务的名称
          url: previewUrl, // 文件地址
          el: '#associatedFiles', // 文件挂载的dom元素
        })
        window.wujie.startApp({ name: 'associatedFiles' })
      }
    },
    // 预览关联模型
    async viewModel(data) {
      const [err, res] = await modelApi.get({ id: data.modelId })
      if (!err) {
        // 跳转外部链接查看三维模型
        window.open(
          `${this.basePath}/visualization-cockpit/index?modelInfoId=${res.medias.fileInfoId}`
        )
      }
    },
    // 关联文档树结构分屏
    async splitScreen(data) {
      if (!this.standardId) return
      const res = await DocumentService.findDocAttr({
        id: data.data.documentId,
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        this.$emit('splitScreen', { ...data.data, versionTag: res.data.versionTag })
      }
    },
    // 关联位号点击事件
    clickTagNode(data) {
      if (data.code) {
        this.$emit('changeTagCode', data.code)
      } else {
        // console.log('当前位号没有code')
      }
    },
    // 获取动态表单数据
    async getDynamicTableData() {
      const res = await documentManagementService.getDynamicTableData({
        classId: this.codeInfo.classId,
        dataId: this.codeInfo.id,
      })
      if (res && res.code === 0 && res.data) {
        this.dynamicTableData = res.data
        this.getClassTypeTableHeader()
        this.getDynamicTableGroupHeader()
      } else {
        this.dynamicTableData = []
      }
    },
    // 获取实体类型动态表头
    async getClassTypeTableHeader() {
      if (!this.codeInfo.classId) return
      const res = await documentManagementService.getTagsList({
        standardId: this.standardId,
        classId: this.codeInfo.classId,
        cateCode: 'Tag',
      })
      if (res && res.code === 0 && res.data) {
        this.classTypeTableData = res.data
        Object.keys(this.dynamicTableData).forEach((key) => {
          _.map(this.classTypeTableData, (item) => {
            if (key === `${item.tableName}.${item.columnName}`) {
              item.value = this.dynamicTableData[key]
            }
            if (item.isPrimary) this.isPrimary = item
            return item
          })
        })
      } else {
        this.classTypeTableData = []
      }
    },
    // 获取实体分组动态表头
    async getDynamicTableGroupHeader() {
      if (!this.codeInfo.classId) return
      const res = await documentManagementService.getDynamicList({
        classId: this.codeInfo.classId,
      })
      if (res && res.code === 0 && res.data) {
        this.dynamicTableGroupData = res.data
        Object.keys(this.dynamicTableGroupData).forEach((groupKey) => {
          Object.keys(this.dynamicTableData).forEach((key) => {
            _.map(this.dynamicTableGroupData[groupKey], (item) => {
              if (key === `${item.tableName}.${item.columnName}`) {
                item.value = this.dynamicTableData[key]
              }
              return item
            })
          })
          this.dynamicTableGroupData[groupKey].forEach((obj) => {
            if (obj.isExtend === 1) this.isExtend = obj
          })
        })
        if (this.isExtend) {
          await this.getExtensionList()
          await this.getExtendDataList()
        }
      } else {
        this.dynamicTableGroupData = []
      }
    },
    // 获取扩展属性下拉数据
    async getExtensionList() {
      const res = await documentManagementService.getExtendClassList({
        classId: this.isExtend.classId,
      })
      if (res && res.code === 0) {
        this.extendValue = []
        this.extendValue = res.data.find((item) => {
          return item.extendClassCode === this.isExtend.value
        })
      }
    },
    // 获取扩展属性数据
    async getExtendDataList() {
      if (!this.extendValue || !this.extendValue.extendClassCode) return
      const params = {
        maxResultCount: this.page.pageSize,
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
        attributeId: this.extendValue.classAttributeId,
        attributeData: this.extendValue.extendClassCode,
        data: this.isPrimary?.value,
      }
      const res = await documentManagementService.getExtendData(params)
      if (res && res.code === 0) {
        this.flag = res.data.flag
        // this.flag = 1
        if (this.flag === 0) {
          const val = res.data.data?.data[0]
          Object.keys(val).forEach((item) => {
            res.data.attributeDataModels.forEach((el) => {
              if (`${el.tableName}.${el.columnName}` === item) {
                el.value = val[item]
              }
            })
          })
          this.$set(
            this.dynamicTableGroupData,
            this.extendValue.extendClassName,
            res.data.attributeDataModels
          )
        } else {
          this.extendTableHeader = res.data.attributeDataModels
          this.extendValueList = res.data.data.data
          this.page.total = res.data.data.totalCount
          this.$set(this.dynamicTableGroupData, this.extendValue.extendClassName, [])
        }
      }
    },
    // 获取关联数据智能推荐
    async getSmartRecommendQuery() {
      if (!this.standardId) return
      this.recommendLinkedDataList = []
      const res = await documentManagementService.smartRecommendQuery({
        classTypes: [],
        keyword: this.linkedDataKeyword,
        pageIndex: 1,
        pageSize: 999,
        searchMode: 0,
        searchSource: 2,
        standardId: this.standardId,
        classTypeCode: 'Tag',
      })
      if (res && res.code === 0 && res.data) {
        this.recommendLinkedDataList = res.data
      }
    },
    // 获取关联文档智能推荐
    async getDocSmartRecommendQuery() {
      if (!this.standardId) return
      this.smartTreeFiles = []
      const res = await documentManagementService.smartRecommendQuery({
        classTypes: [],
        keyword: '',
        pageIndex: 1,
        pageSize: 999,
        searchMode: 0,
        searchSource: 2,
        standardId: this.standardId,
        classTypeCode: 'Document',
      })
      if (res && res.code === 0 && res.data) {
        this.smartTreeFiles = res.data.map((item) => {
          item.documentName = item.className
          return item
        })
      }
    },
    // 获取关联模型数据
    async getAssociativeMdels() {
      this.associativeMdelsList = []
      const res = await ModelParsingTaskService.getModelObjectRelationList({
        skipCount: 0,
        maxResultCount: 999,
        standardId: this.standardId,
        // classId: this.codeInfo.classId,
        modelName: '',
        dataId: this.codeInfo.id,
      })
      if (res && res.code === 0 && res.data) {
        this.associativeMdelsList = res.data
      }
    },
  },
}
</script>
<style lang="scss" scoped>

.overflow-y-auto {
  overflow-y: auto;
}
/deep/.el-tabs {
  border-bottom: 0;
  .el-tabs__content {
    height: calc(100% - 35px);
    overflow-y: auto;
  }
}
.tabs-item-box {
  /deep/.el-tabs__content {
    height: 296px;
    overflow-y: scroll;
    box-sizing: border-box;
  }
  // border-bottom: 1px solid #eee;
}
/deep/.el-tree {
  padding: 10px 0px;
  .el-tree-node__label {
    font-size: 12px !important;
  }
  .el-tree-node__content {
    border-bottom: 1px solid rgb(248, 248, 248);
    height: 32px;
    font-size: 12px;
  }
}
/deep/.el-tabs__item {
  font-size: 12px;
}
#bitRelational {
  width: 390px;
  height: 424px;
  right: 20px;
  top: 75px;
  background-color: #fff;
  box-shadow: 0px 0px 1px 4px #dcdbdb91;
  border-radius: 4px;
  z-index: 2000;
  overflow: hidden;
}
/deep/.el-dialog__header {
  text-align: left !important;
  font-size: 14px !important;
  font-weight: bold !important;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}
.node-treeLable {
  width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 32px;
  line-height: 32px;
}
.activeColor {
  color: #1890ff !important;
}
.position-absolute {
  position: absolute;
}
.border-color-grey-f5-bottom {
  border-bottom: 1px solid #f5f5f5 !important;
}
.has-text-weight-semibold {
  font-weight: 600 !important;
  font-size: 12px;
}
.hover-color {
  &:hover {
    background: #f2f6fc;
  }
}
/deep/.el-tabs__nav-wrap:after {
  background-color: transparent !important;
}
/deep/.el-divider--horizontal {
  margin: 0 !important;
}

</style>
